'use strict';

require('./CompanyMessageService.js');
require('../blogs/CompanyMessageDetailCtrl.js');
require('../groups/CompanyGroupService.js');


function groupsToString(groups) {
  var ids = "";
  angular.forEach(groups, function(v, k){
    if (k === 0) {
      ids = v.id;
    } else {
      ids = ids + ',' + v.id;
    }
  });
  return ids;
}

CompanyMessageDetailCtrl.$inject = [
  '$scope',
  '$stateParams',
  '$state',
  '$translate',
  '$q',
  'members',
  'CompanyMessageService',
  'CompanyGroupService',
  'CompanyGroupUserService',
  'CompanyUserService',
  'message',
  'growl'];

function CompanyMessageDetailCtrl(
  $scope,
  $stateParams,
  $state,
  $translate,
  $q,
  members,
  CompanyMessageService,
  CompanyGroupService,
  CompanyGroupUserService,
  CompanyUserService,
  message,
  growl) {

  $scope.post = message;
  $scope.submitting = false;
  $scope.members = members.map(function(m){
    return {email: m.email};
  });

  if (!message) {
    $scope.post = {
      name: "",
      groups: [],
      extra: {
        sendToList: true,
        sendToAll: false,
        sendEmail: false,
        listSendMail: []
      },
      showMessageList: false
    };
  }

  function filterIds(groups) {
    return groups.map(function(v){
      return v.id;
    });
  }

  $scope.ids = filterIds($scope.post.groups);

  $scope.addGroup = function(g) {
    $scope.post.groups.push(g);
    $scope.ids = filterIds($scope.post.groups);
    if($scope.post.extra.sendToAll){
      CompanyUserService.query({
        companyId: $stateParams.companyId,
        groupIds: groupsToString($scope.post.groups),
        all: true
      }).$promise.then(function(members){
        $scope.members = $scope.members.concat(members.map(function(m){
          return {email: m.email, name: m.name};
        }));
      });
    }
  };

  $scope.removeGroup = function(i) {
    $scope.post.groups.splice(i, 1);
    $scope.ids = filterIds($scope.post.groups);
  };

  $scope.sendMail = function() {
    $scope.submitting = true;
    return CompanyMessageService.sendMail({
      companyId: $stateParams.companyId,
      messageId: $scope.post.id
    }, {
      listSendMail: $scope.members
    }, function(){
      growl.addSuccessMessage($translate.instant('blog.send-mail-success'));
      $scope.submitting = false;
    }, function(){
      growl.addErrorMessage($translate.instant('blog.send-mail-failure'));
      $scope.submitting = false;
    });
  };

  $scope.save = function() {
    $scope.submitting = true;
    if($scope.members.length > 0){
      $scope.post.extra.listSendMail = angular.copy($scope.members);
    }
    if (!message) {
      CompanyMessageService.save({companyId: $stateParams.companyId}, $scope.post, function(resp){
        $scope.post.id = resp.id;
        if ($scope.members.length > 0) {
          if($scope.post.extra.sendEmail){
            $scope.sendMail().$promise.then(function(){
              $state.go('root.company.message-detail', {messageId: resp.id});
            });
          } else {
            $state.go('root.company.message-detail', {messageId: resp.id});
          }
        } else {
          $state.go('root.company.message-detail', {messageId: resp.id});
        }
        growl.addSuccessMessage($translate.instant('blog.save-success'));
      }, function(){
        $scope.submitting = false;
        growl.addErrorMessage($translate.instant('blog.save-failure'));
      });
    } else {
      CompanyMessageService.update({companyId: $stateParams.companyId, messageId: $scope.post.id}, $scope.post, function(){
        $scope.submitting = false;
        growl.addSuccessMessage($translate.instant('blog.save-success'));
        if ($scope.members.length > 0) {
          if($scope.post.extra.sendEmail){
            $scope.sendMail().$promise.then(function(){
              $scope.members = $scope.members.map(function(v){
                return {
                  email: v.email,
                  sentAt: new Date()
                };
              });
            });
          }
        }
      }, function(){
        $scope.submitting = false;
        growl.addErrorMessage($translate.instant('blog.save-failure'));
      });
    }
  };

  $scope.addEmail = function() {
    $scope.members.push({email: $scope.addedEmail});
    $scope.addedEmail = null;
  };

  $scope.queryGroups = function(filter) {
    CompanyGroupService.query({companyId: $stateParams.companyId, q: filter, limit: 6, type: null}).$promise.then(function(groups) {
      $scope.groups = groups.filter(function(g) {
        return !$scope.post.groups.some(function(g1) {
          return g1.id === g.id;
        });
      });
    });
  };

  $scope.deleteMessage = function() {
    CompanyMessageService.delete({companyId: $stateParams.companyId, messageId: $scope.post.id}).$promise.then(function() {
      growl.addSuccessMessage($translate.instant('blog.delete-message-success'));
      $state.go("root.company.comments.messages");
    }, function() {
      growl.addErrorMessage($translate.instant('blog.delete-message-failure'));
    })

  }
}

CompanyMessageDetailCtrl.resolve = {
  message: ['CompanyMessageService', '$stateParams', function(CompanyMessageService, $stateParams) {
    if ($stateParams.messageId) {
      return CompanyMessageService.get({
        companyId: $stateParams.companyId,
        messageId: $stateParams.messageId
      }).$promise;
    }
    return false; 
  }],
  members: ['CompanyUserService', '$stateParams', 'message', function(CompanyUserService, $stateParams, message) {
    if (message && message.groups.length > 0) {
      return CompanyUserService.query({
        companyId: $stateParams.companyId,
        groupIds: groupsToString(message.groups),
        all: true
      }).$promise;
    }
    return [];    
  }]
};

module.exports = CompanyMessageDetailCtrl;

angular.module('dokiv')
  .controller('CompanyMessageDetailCtrl', CompanyMessageDetailCtrl);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/blogs/CompanyMessageDetailCtrl.js
// module id = 37
// module chunks = 0